import React, { useState } from "react"
import { MainMenuItem } from "../../hooks/useMainMenu"
import { MenuItemBlank, MenuItemWrapper, MenuItemLocal, MobileMenuItemWrapper, ChildrenWrapper, ChildrenItemWrapper, MoreIcon, MoreIconWrapper, ClearLink } from "./menuItem.style"
import { down } from "styled-breakpoints"
import { useBreakpoint } from "styled-breakpoints/react-styled";
import { ButtonArrow } from "../shapes";
import { palette } from "../../styles/global";
import { Link } from "gatsby";

type Props = {
  menuItem: MainMenuItem,
  scrollY: number,
  active: boolean,
  onClick: () => void
}

const MenuItem = ({ menuItem, scrollY, active, onClick }: Props) => {
  const mobile = useBreakpoint(down('lg'))
  const [open, setOpen] = useState(false)

  const getChildren = () => {
    return <ChildrenWrapper scroll={scrollY} open={open} color={menuItem.border ?? ''}>
      {menuItem.children?.map((children, key) => {
        return <ClearLink onClick={onClick} key={key} to={children.url} target={children.blank ? '_blank' : ''}>
          <ChildrenItemWrapper color={menuItem.background ?? ''}>
            <MenuItemBlank background={menuItem.background ?? ''} scroll={scrollY} active={active} outlined={menuItem.outlined}  >{children.title}</MenuItemBlank>
          </ChildrenItemWrapper>
        </ClearLink>
      })}
    </ChildrenWrapper>
  }

  if (mobile) {
    if (!menuItem.children) {
      return <ClearLink onClick={onClick} to={menuItem.url} target={menuItem.blank ? '_blank' : ''}>
        <MobileMenuItemWrapper color={menuItem.background}>
          <MenuItemBlank background={menuItem.background ?? ''} scroll={scrollY} active={active} outlined={menuItem.outlined} >{menuItem.title}</MenuItemBlank>
        </MobileMenuItemWrapper >
      </ClearLink>
    } else {
      return <div onClick={() => { setOpen(!open) }} >
        <MobileMenuItemWrapper color={menuItem.background}>
          {menuItem.children && <>
            <span style={{ textTransform: 'uppercase' }}>
              {menuItem.title}
              <MoreIconWrapper open={open}>
                <MoreIcon color={palette.white} open={open} />
              </MoreIconWrapper>
            </span>
            {getChildren()}
          </>
          }
        </MobileMenuItemWrapper >
      </div>
    }

  } else {
    if (!menuItem.children) {
      return <ClearLink onClick={onClick} to={menuItem.url} target={menuItem.blank ? '_blank' : ''}>
        <MenuItemWrapper outlined={menuItem.outlined} active={active} scroll={scrollY} border={menuItem.border}>
          <MenuItemBlank background={menuItem.background ?? ''} scroll={scrollY} active={active} outlined={menuItem.outlined}  >{menuItem.title}</MenuItemBlank>
        </MenuItemWrapper>
      </ClearLink>
    } else {
      return <MenuItemWrapper onClick={() => { setOpen(!open) }} onMouseEnter={() => { setOpen(true) }} onMouseLeave={() => { setOpen(false) }} outlined={menuItem.outlined} active={active} scroll={scrollY} border={menuItem.border}>
        {menuItem.children && <>
          <span style={{ textTransform: 'uppercase' }}>{menuItem.title}</span>
          {getChildren()}

        </>}
      </MenuItemWrapper>
    }

  }


}

export default MenuItem